import { render, staticRenderFns } from "./OutputPoolCard.vue?vue&type=template&id=e230d058"
import script from "./OutputPoolCard.vue?vue&type=script&lang=js"
export * from "./OutputPoolCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports